/**
 * Keep in sync with `$breakpoint-small-large` and `$breakpoint-large`
 * from `@des/styles/variables/_breakpoints.scss`.
 */
export const TABLET_BREAKPOINT = 768;
export const DESKTOP_BREAKPOINT = 1280;

/** Min-width media queries for `<source media>` / picture sources. */
export const TABLET_MEDIA_QUERY = `(min-width: ${TABLET_BREAKPOINT}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_BREAKPOINT}px)`;
